export enum TenantName {
  Aetna = 'Anthem',
  Anthem = 'Anthem',
  Humana = 'Humana',
  UnitedHealthcare = 'UnitedHealthcare',
}
